<ng-template #fetching>
    <div class="validating">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<ng-template #countdown let-data="data">
    <div class="count-down">
        <app-same-day-delivery-count-down
            [zipCode]="zipCode"
            [status]="sameDayDeliveryStatus"
            [showIcon]="data?.showIcon"
            [showTooltip]="data?.showTooltip"
            [longTimeFormat]="data?.longFormat"
        ></app-same-day-delivery-count-down>
    </div>
</ng-template>

<ng-template #little>
    <ng-container
        *ngTemplateOutlet="countdown; context: { data: { showIcon: true, showTooltip: true, sameDayDeliveryStatus } }"
    ></ng-container>

    <div class="contents">
        <div class="form-group">
            <app-input-zipcode
                [clearButton]="true"
                marginBottom="none"
                [placeholder]="'sameDayDelivery.placeholders.zipCode' | translateSafe"
                [control]="zipCodeFormControl"
            ></app-input-zipcode>
        </div>
        <div
            class="form-group-status"
            *ngIf="!validating; else fetching"
            [ngClass]="{
                'form-group-status--idle': sameDayDeliveryStatus === 'Idle',
                'form-group-status--valid': sameDayDeliveryStatus === 'Valid',
                'form-group-status--invalid': sameDayDeliveryStatus === 'Invalid'
            }"
        >
            <span
                class="kk-status"
                [ngClass]="{
                    'kk-status--idle': sameDayDeliveryStatus === 'Idle',
                    'kk-status--valid': sameDayDeliveryStatus === 'Valid',
                    'kk-status--invalid': sameDayDeliveryStatus === 'Invalid',
                    'kk-status--warning':
                        sameDayDeliveryStatus === 'WeekendMode' ||
                        sameDayDeliveryStatus === 'HolidayMode' ||
                        sameDayDeliveryStatus === 'TimeIsUp'
                }"
            >
                @if (sameDayDeliveryStatus === 'Valid') {
                    <app-svg-icon iconName="tick"></app-svg-icon>
                } @else {
                    <app-svg-icon iconName="error"></app-svg-icon>
                }
            </span>
            <ng-container [ngSwitch]="sameDayDeliveryStatus">
                <span
                    class="validation-feedback"
                    *ngSwitchCase="'Idle'"
                    [innerHTML]="
                        'sameDayDelivery.validations.idleStatus'
                            | translateSafe: { deliveryCutoffTime: timeLeft | date: 'HH' }
                    "
                ></span>
                <span
                    class="validation-feedback"
                    *ngSwitchCase="'Valid'"
                    [innerHTML]="'sameDayDelivery.validations.validStatus' | translateSafe: { deliveryCutoffTime: timeLeft | date: 'HH', zipCode }"
                ></span>
                <span
                    class="validation-feedback"
                    *ngSwitchCase="'Invalid'"
                    [innerHTML]="'sameDayDelivery.validations.invalidStatus' | translateSafe: { deliveryCutoffTime: timeLeft | date: 'HH', zipCode }"
                ></span>
                <span
                    class="validation-feedback"
                    *ngSwitchCase="'TimeIsUp'"
                    [innerHTML]="
                        'sameDayDelivery.validations.afterTimeOverValidZipCode' | translateSafe: { deliveryCutoffTime: timeLeft | date: 'HH', zipCode }
                    "
                ></span>
                <span
                    class="validation-feedback"
                    *ngSwitchCase="'WeekendMode'"
                    [innerHTML]="'sameDayDelivery.weekendMode.information' | translateSafe : { zipCode }"
                ></span>
                <span
                    class="validation-feedback"
                    *ngSwitchCase="'HolidayMode'"
                    [innerHTML]="'sameDayDelivery.holidayMode.information' | translateSafe : { zipCode }"
                ></span>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #normal>
    <form *ngIf="sameDayDeliveryStatus !== 'WeekendMode'" class="contents normal">
        <div class="form-group normal">
            <label class="kk-visuallyhidden" for="search">{{
                    'sameDayDelivery.placeholders.searchZipCode' | translateSafe
                }}</label>
            <button type="submit" class="icon icon-left">
                <span class="kk-visuallyhidden">{{
                        'sameDayDelivery.placeholders.searchZipCode' | translateSafe
                    }}</span>
                <app-svg-icon iconName="search"></app-svg-icon>
            </button>
            <input
                [formControl]="zipCodeFormControl"
                [placeholder]="'sameDayDelivery.placeholders.searchZipCode' | translateSafe"
                class="kk-input-textlike"
                id="search"
                type="number"
                autocomplete="off"
                size="10"
            />
            <div class="spinner" *ngIf="validating; else clearButton">
                <app-loading-dots></app-loading-dots>
            </div>
            <ng-template #clearButton>
                <button
                    *ngIf="zipCodeFormControl.value?.length"
                    (click)="onClearField()"
                    type="button"
                    class="icon clear-button kk-content-fade-in"
                >
                    <app-svg-icon iconName="close"></app-svg-icon>
                </button>
            </ng-template>
        </div>
    </form>

    <div class="feedback" *ngIf="timeLeft; else fetching" [ngSwitch]="sameDayDeliveryStatus">
        <span
            class="kk-status"
            [ngClass]="{
                'kk-status--idle': sameDayDeliveryStatus === 'Idle',
                'kk-status--valid': sameDayDeliveryStatus === 'Valid',
                'kk-status--invalid': sameDayDeliveryStatus === 'Invalid',
                'kk-status--warning':
                    sameDayDeliveryStatus === 'WeekendMode' ||
                    sameDayDeliveryStatus === 'HolidayMode' ||
                    sameDayDeliveryStatus === 'TimeIsUp'
            }"
        >
            @if (sameDayDeliveryStatus === 'Valid') {
                <app-svg-icon iconName="tick"></app-svg-icon>
            } @else {
                <app-svg-icon iconName="error"></app-svg-icon>
            }
        </span>

        <ng-container
            *ngSwitchCase="'Valid'"
            [ngTemplateOutlet]="countdown"
            [ngTemplateOutletContext]="{ data: { showIcon: false, showTooltip: false, sameDayDeliveryStatus } }"
        ></ng-container>
        <p
            class="text-bold"
            *ngSwitchCase="'Idle'"
            [innerHTML]="
                'sameDayDelivery.validations.waitingForInput'
                    | translateSafe: { deliveryCutoffTime: timeLeft | date: 'HH' }
            "
        ></p>
        <p
            class="text-bold"
            *ngSwitchCase="'TimeIsUp'"
            [innerHTML]="'sameDayDelivery.afterTimeOver' | translateSafe: { deliveryCutoffTime: timeLeft | date: 'HH' }"
        ></p>
        <p
            class="text-bold"
            *ngSwitchCase="'Invalid'"
            [innerHTML]="'sameDayDelivery.validations.invalidZipCode' | translateSafe : { zipCode }"
        ></p>

        <p
            class="text-bold"
            *ngSwitchCase="'WeekendMode'"
            [innerHTML]="'sameDayDelivery.weekendMode.information' | translateSafe : { zipCode }"
        ></p>
        <p
            class="text-bold"
            *ngSwitchCase="'HolidayMode'"
            [innerHTML]="'sameDayDelivery.holidayMode.information' | translateSafe : { zipCode }"
        ></p>
    </div>
</ng-template>

<div class="wrapper">
    <ng-container [ngSwitch]="layout">
        <ng-template *ngSwitchCase="'little'" [ngTemplateOutlet]="little"></ng-template>
        <ng-template *ngSwitchCase="'normal'" [ngTemplateOutlet]="normal"></ng-template>
    </ng-container>
</div>
